var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.5C13.6 8.5 14.5 7.6 14.5 6.5C14.5 5.4 13.6 4.5 12.5 4.5C11.4 4.5 10.5 5.4 10.5 6.5C10.5 7.6 11.4 8.5 12.5 8.5ZM12.5 10.5C11.4 10.5 10.5 11.4 10.5 12.5C10.5 13.6 11.4 14.5 12.5 14.5C13.6 14.5 14.5 13.6 14.5 12.5C14.5 11.4 13.6 10.5 12.5 10.5ZM10.5 18.5C10.5 17.4 11.4 16.5 12.5 16.5C13.6 16.5 14.5 17.4 14.5 18.5C14.5 19.6 13.6 20.5 12.5 20.5C11.4 20.5 10.5 19.6 10.5 18.5Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActions);
export default __webpack_public_path__ + "static/media/iconActions.de1199e43c3bf78b8bb8215bcd841f43.svg";
export { ForwardRef as ReactComponent };